// Vendors
import $ from 'jquery';
import anime from 'animejs/lib/anime.es.js';

// hero animation
$(document).ready(function () {
  if ($('body.home').length) {
    const homeHeroBanner = document.getElementById('home_hero_banner');

    const homeLogos = document.getElementsByClassName('logo-image-home');

    const homeHeroCopy = document.getElementById('home_hero_copy');
    const homeHeroCopyStart = 'position: relative; left: 20px; opacity: 0;';

    const ribbonOne = document.getElementById('ribbon_one');
    const ribbonOneStart = '492.1,1500 196.7,1500 196.7,1500 492.1,1500';
    const ribbonOneFinish = '158.7,922.6 11,1178.4 196.7,1500 492.1,1500';

    const ribbonTwo = document.getElementById('ribbon_two');
    const ribbonTwoStart = '11,1178.4   11,1178.4   158.7,922.6   158.7,922.6';
    const ribbonTwoFinish = '11,1178.4 645.2,1060.3 939.7,678 158.7,922.6';

    const ribbonThree = document.getElementById('ribbon_three');
    const ribbonThreeStart =
      '645.2,1060.3   645.2,1060.3   939.7,678   939.7,678';
    const ribbonThreeFinish = '645.2,1060.3 0,0 569,0 939.7,678';

    // Set the initial styling using jQuery
    $(ribbonOne).attr('points', ribbonOneStart);
    $(ribbonTwo).attr('points', ribbonTwoStart);
    $(ribbonThree).attr('points', ribbonThreeStart);
    $(homeHeroCopy).attr('style', homeHeroCopyStart);
    $(homeLogos).css('opacity', '0');

    // Use Anime.js timeline to animate the points attribute
    let timelineHero = anime.timeline();

    timelineHero
      .add({
        targets: homeHeroBanner,
        opacity: 1,
        easing: 'linear',
        delay: 500,
        duration: 500
      })
      .add(
        {
          targets: ribbonOne,
          points: [{ value: ribbonOneStart }, { value: ribbonOneFinish }],
          easing: 'easeInQuad',
          duration: 500
        },
        1000
      )
      .add(
        {
          targets: ribbonTwo,
          points: [{ value: ribbonTwoStart }, { value: ribbonTwoFinish }],
          easing: 'linear',
          duration: 300
        },
        1400
      )
      .add(
        {
          targets: ribbonThree,
          points: [{ value: ribbonThreeStart }, { value: ribbonThreeFinish }],
          easing: 'easeOutQuad',
          duration: 500
        },
        1500
      )
      .add({
        targets: homeLogos,
        opacity: 1,
        easing: 'linear',
        duration: 500
      })
      .add({
        targets: homeHeroCopy,
        translateX: -20,
        opacity: 1,
        easing: 'easeOutQuad',
        duration: 500
      });

    /******  Section One Animation  **********/
    const elementOne = $('#home_section_one');
    const elementOneTitle = document.getElementById('element_one_title');
    const elementOneContent = document.getElementById('element_one_content');
    const elementOneButton = document.getElementById('element_one_button');
    const elementOneBackground = document.getElementById(
      'element_one_background'
    );

    // image start and positions
    const elementOneImage = document.querySelector(
      '#element_one_image_clip_path'
    );

    //Set initial styling with jQuery
    $(elementOneImage).attr(
      'style',
      'max-width: 0; -webkit-clip-path: polygon(0 0,0 778px,1182px 778px,1182px 0); clip-path: polygon(0 0,0 778px,1182px 778px,1182px 0)'
    );
    $(elementOneTitle).attr('style', 'left: -20px; opacity: 0;');
    $(elementOneContent).attr('style', 'left: -20px; opacity: 0;');
    $(elementOneButton).attr('style', 'left: -20px; opacity: 0;');
    $(elementOneBackground).attr('style', 'left: -610px; opacity: 0;');

    // create timeline of animations
    let timelineOne = anime.timeline({
      autoplay: false
    });

    timelineOne
      .add({
        targets: elementOneImage,
        maxWidth: '100%',
        duration: 500,
        easing: 'easeInQuad'
      })
      .add(
        {
          targets: elementOneImage,
          clipPath: 'polygon(400px 0,270px 778px,1182px 778px,1182px 0)',
          duration: 500,
          easing: 'easeOutQuad'
        },
        400
      )
      .add(
        {
          targets: elementOneTitle,
          translateX: 20,
          opacity: 1,
          duration: 400,
          easing: 'easeOutQuad'
        },
        1000
      )
      .add(
        {
          targets: elementOneContent,
          translateX: 20,
          opacity: 1,
          duration: 400,
          easing: 'easeOutQuad'
        },
        1300
      )
      .add(
        {
          targets: elementOneButton,
          translateX: 20,
          opacity: 1,
          duration: 400,
          easing: 'easeOutQuad'
        },
        1600
      )
      .add({
        targets: elementOneBackground,
        translateX: 610,
        opacity: 1,
        duration: 1000,
        easing: 'easeOutQuad'
      });

    // check if element is on page
    if (elementOne.length) {
      const elementOnePosition = elementOne.offset().top;
      $(window).on('scroll.animationOne', function () {
        let scrollPosition = $(window).scrollTop() + $(window).height();
        let triggerPosition = elementOnePosition + $(window).height() / 3;

        // only animate once
        if (scrollPosition > triggerPosition) {
          timelineOne.play();
          $(window).off('scroll.animationOne');
        }
      });
    }

    /****** Section Two Animations *******/
    const elementTwo = $('#home_section_two');
    const elementTwoImage = document.querySelector(
      '#home_section_two .desktop-image'
    );
    const elementTwoSmallTitle = document.querySelector(
      '#home_section_two .desktop-h3'
    );
    const elementTwoLargeTitle = document.querySelector(
      '#home_section_two .desktop-h4'
    );
    const elementTwoContent = document.querySelector(
      '#home_section_two .desktop-content'
    );
    const elementTwoButton = document.querySelector(
      '#home_section_two .desktop-a'
    );

    // set initial styling with jquery
    $(elementTwoImage).attr('style', 'max-width: 0;');
    $(elementTwoSmallTitle).attr('style', 'bottom: -20px; opacity: 0;');
    $(elementTwoSmallTitle).addClass('hide-line');
    $(elementTwoLargeTitle).attr('style', 'bottom: -20px; opacity: 0;');
    $(elementTwoContent).attr('style', 'bottom: -20px; opacity: 0;');
    $(elementTwoButton).attr('style', 'bottom: -20px; opacity: 0;');

    // create timeline of animations
    let timelineTwo = anime.timeline({
      autoplay: false
    });

    timelineTwo
      .add({
        targets: elementTwoImage,
        maxWidth: '100%',
        duration: 500,
        easing: 'easeInQuad'
      })
      .add({
        targets: elementTwoSmallTitle,
        translateY: -20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad',
        changeComplete: function () {
          elementTwoSmallTitle.classList.remove('hide-line');
        }
      })
      .add({
        targets: elementTwoLargeTitle,
        translateY: -20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad'
      })
      .add({
        targets: elementTwoContent,
        translateY: -20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad'
      })
      .add({
        targets: elementTwoButton,
        translateY: -20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad'
      });

    // check if element is on page
    if (elementTwo.length) {
      const elementTwoPosition = elementTwo.offset().top;
      $(window).on('scroll.animationTwo', function () {
        let scrollPosition = $(window).scrollTop() + $(window).height();
        let triggerPosition = elementTwoPosition + $(window).height() / 3;

        // only animate once
        if (scrollPosition > triggerPosition) {
          timelineTwo.play();
          $(window).off('scroll.animationTwo');
        }
      });
    }

    /********** Section Three Ribbon Animation ********/
    const elementThreeRibbonTrigger = $('#section_three_large_title');
    const elementThreeRibbonOne = document.getElementById(
      'section_three_ribbon_one'
    );
    const elementThreeRibbonTwo = document.getElementById(
      'section_three_ribbon_two'
    );

    // set initial styling
    $(elementThreeRibbonOne).attr('points', '0,0 0,0 0,232 0,232');
    $(elementThreeRibbonTwo).attr(
      'points',
      '645.2,104.1 645.2,104.1 939.7,486.4 939.7,486.4'
    );

    // create ribbon timeline
    let timelineThreeRibbon = anime.timeline({
      autoplay: false
    });

    timelineThreeRibbon
      .add({
        targets: elementThreeRibbonOne,
        points: [
          { value: '0,0 0,0 0,232 0,232' },
          { value: '0,0 645.2,104.1 939.7,486.4 0,232' }
        ],
        easing: 'easeInQuad',
        duration: 400
      })
      .add(
        {
          targets: elementThreeRibbonTwo,
          points: [
            { value: '645.2,104.1 645.2,104.1 939.7,486.4 939.7,486.4' },
            { value: '645.2,104.1 0,453.5 0,1418.8 939.7,486.4' }
          ],
          easing: 'easeOutQuad',
          duration: 400
        },
        250
      );

    // set up trigger
    if (elementThreeRibbonTrigger.length) {
      const elementThreeRibbonTriggerPosition =
        elementThreeRibbonTrigger.offset().top;
      $(window).on('scroll.animationThreeRibbon', function () {
        let scrollPosition = $(window).scrollTop() + $(window).height();
        let triggerPosition =
          elementThreeRibbonTriggerPosition + $(window).height() / 3;

        // only animate once
        if (scrollPosition > triggerPosition) {
          timelineThreeRibbon.play();
          $(window).off('scroll.animationThreeRibbon');
        }
      });
    }

    /******** Section Three Large Title Scroll ******/
    const elementThreeLargeTitlePosition = document.getElementById(
      'section_three_large_title'
    );
    const elementThreeLargeTitle = document.querySelector(
      '#section_three_large_title h2.desktop-title'
    );

    if (elementThreeLargeTitle) {
      //set initial position
      elementThreeLargeTitle.style.right = '0';

      // use the section three ribbon trigger to also move the large title
      window.addEventListener('scroll', () => {
        const rect = elementThreeLargeTitlePosition.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const position = (rect.top / windowHeight) * -1200;
        const adjustedPosition = position + 100;
        elementThreeLargeTitle.style.right = adjustedPosition + 'px';
      });
    }

    /******* Section Three Main Animation *******/
    const elementThreeMain = $('#section_three_main_container');
    const elementThreeSmallTitle = document.querySelector(
      '#section_three_main_container .content h3'
    );
    const elementThreeMainTitle = document.querySelector(
      '#section_three_main_container .content h4'
    );
    const elementThreeButton = document.querySelector(
      '#section_three_main_container .content a.btn'
    );

    // set initial styling with jquery
    $(elementThreeSmallTitle).attr('style', 'left: -20px; opacity: 0;');
    $(elementThreeSmallTitle).addClass('hide-line');
    $(elementThreeMainTitle).attr('style', 'left: -20px; opacity: 0;');
    $(elementThreeButton).attr('style', 'left: -20px; opacity: 0;');
    $('.home-section-logo-gallery .desktop-logos img').attr(
      'style',
      'top: -200px; opacity: 0;'
    );

    // create timeline of animations
    let timelineThree = anime.timeline({
      autoplay: false
    });

    timelineThree
      .add({
        targets: elementThreeSmallTitle,
        translateX: 20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad',
        changeComplete: function () {
          elementThreeSmallTitle.classList.remove('hide-line');
        }
      })
      .add({
        targets: elementThreeMainTitle,
        translateX: 20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad'
      })
      .add({
        targets: elementThreeButton,
        translateX: 20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad'
      })
      .add({
        targets: '.home-section-logo-gallery img',
        top: '0px',
        opacity: 1,
        delay: anime.stagger(200, { from: 'first' }),
        easing: 'spring(1, 80, 10, 10)',
        duration: 1000
      });

    // triggers
    if (elementThreeMain.length) {
      const elementThreePosition = elementThreeMain.offset().top;
      $(window).on('scroll.animationThree', function () {
        let scrollPosition = $(window).scrollTop() + $(window).height();
        let triggerPosition = elementThreePosition + $(window).height() / 3;

        // only animate once
        if (scrollPosition > triggerPosition) {
          timelineThree.play();
          $(window).off('scroll.animationThree');
        }
      });
    }

    /******* Section Four Animations ********/
    const elementFourMain = $('#home_section_four');
    const elementFourTitle = document.querySelector('#home_section_four h3');
    const elementFourGrid = document.querySelector(
      '#home_section_four .number-grid.desktop-numbers'
    );

    // set styling
    $(elementFourTitle).attr('style', 'bottom: -20px; opacity: 0;');
    $(elementFourTitle).addClass('hide-line');
    $(elementFourGrid).attr('style', 'opacity: 0;');
    $('#home_section_four .desktop-numbers .number-animate').attr(
      'style',
      'bottom: -20px; opacity: 0;'
    );

    // create timeline
    let timelineFour = anime.timeline({
      autoplay: false
    });

    timelineFour
      .add({
        targets: elementFourTitle,
        translateY: -20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad',
        changeComplete: function () {
          elementFourTitle.classList.remove('hide-line');
        }
      })
      .add({
        targets: elementFourGrid,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad'
      })
      .add({
        targets: '.number-grid.desktop-numbers .number-animate',
        translateY: -20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad',
        delay: anime.stagger(200, { from: 'first' })
      });

    // triggers
    if (elementFourMain.length) {
      const elementFourPosition = elementFourMain.offset().top;
      $(window).on('scroll.animationFour', function () {
        let scrollPosition = $(window).scrollTop() + $(window).height();
        let triggerPosition = elementFourPosition + $(window).height() / 3;

        // only animate once
        if (scrollPosition > triggerPosition) {
          timelineFour.play();
          $(window).off('scroll.animationFour');
        }
      });
    }

    /******** Section Five Large Title Scroll ******/
    const elementFiveLargeTitlePosition = document.getElementById(
      'section_five_large_title'
    );
    const elementFiveLargeTitle = document.querySelector(
      '#section_five_large_title h2.desktop'
    );

    if (elementFiveLargeTitle) {
      //set initial position
      elementFiveLargeTitle.style.right = '0';

      // trigger on scroll
      window.addEventListener('scroll', () => {
        const rect = elementFiveLargeTitlePosition.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const position = (rect.top / windowHeight) * -2000;
        const adjustedPosition = position + 1200;
        elementFiveLargeTitle.style.right = adjustedPosition + 'px';
      });
    }

    /******* Section Five Main Animation ******/
    const elementFive = $('#home_section_five');
    // image start and positions
    const elementFiveImage = document.querySelector(
      '#element_five_image_clip_path'
    );
    const elementFiveTitle = document.querySelector('#home_section_five h3');
    const elementFiveContent = document.querySelector('#home_section_five p');
    const elementFiveButton = document.querySelector(
      '#home_section_five a.btn'
    );

    //Set initial styling with jQuery
    $(elementFiveImage).attr(
      'style',
      'max-width: 0; -webkit-clip-path: polygon(0 0, 0 0, 0 545px,0 545px); clip-path: polygon(0 0, 0 0, 0 545px,0 545px)'
    );
    $(elementFiveTitle).attr('style', 'right: -40px; opacity: 0;');
    $(elementFiveContent).attr('style', 'right: -40px; opacity: 0;');
    $(elementFiveButton).attr('style', 'right: -40px; opacity: 0;');

    // create timeline of animations
    let timelineFive = anime.timeline({
      autoplay: false
    });

    timelineFive
      .add({
        targets: elementFiveImage,
        maxWidth: '100%',
        duration: 500,
        easing: 'easeInQuad'
      })
      .add({
        targets: elementFiveImage,
        clipPath: 'polygon(0 0,818px 0,738px 545px,0 545px)',
        duration: 500,
        easing: 'easeOutQuad'
      })
      .add({
        targets: [elementFiveTitle, elementFiveContent, elementFiveButton],
        translateX: -20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad',
        delay: anime.stagger(400, { from: 'first' })
      });

    // trigger animations
    if (elementFive.length) {
      const elementFivePosition = elementFive.offset().top;
      $(window).on('scroll.animationFive', function () {
        let scrollPosition = $(window).scrollTop() + $(window).height();
        let triggerPosition = elementFivePosition + $(window).height() / 3;

        // only animate once
        if (scrollPosition > triggerPosition) {
          $('#home_section_five').addClass('animate-border');
          timelineFive.play();
          $(window).off('scroll.animationFive');
        }
      });
    }

    /****** Section Six Animations ******/
    const elementSixMain = $('#home_section_six');
    const bottomLeftRibbonOne = document.getElementById(
      'bottom_left_ribbon_one'
    );
    const bottomLeftRibbonTwo = document.getElementById(
      'bottom_left_ribbon_two'
    );
    const elementSixSmallTitle = document.querySelector(
      '#home_section_six .content h3'
    );
    const elementSixTitle = document.querySelector(
      '#home_section_six .content h4'
    );
    const elementSixContent = document.querySelector(
      '#home_section_six .content p'
    );
    const elementSixButton = document.querySelector(
      '#home_section_six .content a.btn'
    );
    const bottomRightRibbonOne = document.getElementById(
      'bottom_right_ribbon_one'
    );
    const bottomRightRibbonTwo = document.getElementById(
      'bottom_right_ribbon_two'
    );
    const bottomRightRibbonThree = document.getElementById(
      'bottom_right_ribbon_three'
    );
    const elementSixImage = document.querySelector(
      '#home_section_six img.desktop-image'
    );

    // set initial styling
    $(bottomLeftRibbonOne).attr('points', '0,0 0,0 0,482 0,482');
    $(bottomLeftRibbonTwo).attr(
      'points',
      '468.8,668.6 468.8,668.6 429.9,961.4 429.9,961.4'
    );
    $(elementSixSmallTitle).attr('style', 'left: -20px; opacity: 0;');
    $(elementSixTitle).attr('style', 'left: -20px; opacity: 0;');
    $(elementSixContent).attr('style', 'left: -20px; opacity: 0;');
    $(elementSixButton).attr('style', 'left: -20px; opacity: 0;');
    $(bottomRightRibbonOne).attr(
      'points',
      '939.7,965.3    939.7,965.3   939.7,0    939.7,0' // bottom left, bottom right , top right, top left
    );
    $(bottomRightRibbonTwo).attr(
      'points',
      '294.5,1314.7   294.5,1314.7   0,932.4   0,932.4' // bottom right, bottom left, top left, top right
    );
    $(bottomRightRibbonThree).attr(
      'points',
      '780.9,1176.9   743,1754.4   743,1754.4   780.9,1176.9' // top left, top right, bottom right, bottom left
    );
    $(elementSixImage).attr('style', 'opacity: 0;');

    // create ribbon timeline
    let timelineSix = anime.timeline({
      autoplay: false
    });

    timelineSix
      .add({
        targets: bottomLeftRibbonOne,
        points: [
          { value: '0,0 0,0 0,482 0,482' },
          { value: '468.8,668.6 0,0 0,482 429.9,961.4' }
        ],
        easing: 'easeInQuad',
        duration: 400
      })
      .add(
        {
          targets: bottomLeftRibbonTwo,
          points: [
            { value: '468.8,668.6 468.8,668.6 429.9,961.4 429.9,961.4' },
            { value: '468.8,668.6 0,862 0,1138.8 429.9,961.4' }
          ],
          easing: 'easeOutQuad',
          duration: 400
        },
        250
      )
      .add({
        targets: [
          elementSixSmallTitle,
          elementSixTitle,
          elementSixContent,
          elementSixButton
        ],
        translateX: 20,
        opacity: 1,
        duration: 400,
        easing: 'easeInQuad',
        delay: anime.stagger(400, { from: 'first' })
      })
      .add(
        {
          targets: bottomRightRibbonOne,
          points: [
            { value: '939.7,965.3 939.7,965.3 939.7,0 939.7,0' },
            { value: '294.5,1314.7 939.7,965.3 939.7,0 0,932.4' }
          ],
          easing: 'easeInQuad',
          duration: 500
        },
        1000
      )
      .add(
        {
          targets: bottomRightRibbonTwo,
          points: [
            { value: '294.5,1314.7   294.5,1314.7   0,932.4   0,932.4' },
            { value: '928.7,1432.8 294.5,1314.7 0,932.4 780.9,1176.9' }
          ],
          easing: 'linear',
          duration: 300
        },
        1400
      )
      .add(
        {
          targets: bottomRightRibbonThree,
          points: [
            { value: '780.9,1176.9   743,1754.4   743,1754.4   780.9,1176.9' },
            { value: '780.9,1176.9 928.7,1432.8 743,1754.4 447.5,1754.4' }
          ],
          easing: 'easeOutQuad',
          duration: 500
        },
        1500
      )
      .add({
        targets: elementSixImage,
        opacity: 1,
        easing: 'easeOutQuad',
        duration: 500
      });

    // set up trigger
    if (elementSixMain.length) {
      const elementSixMainPosition = elementSixMain.offset().top;
      $(window).on('scroll.animationSixRibbon', function () {
        let scrollPosition = $(window).scrollTop() + $(window).height();
        let triggerPosition = elementSixMainPosition + $(window).height() / 4;

        // only animate once
        if (scrollPosition > triggerPosition) {
          timelineSix.play();
          $(window).off('scroll.animationSixRibbon');
        }
      });
    }
  }
});
